/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_EditInputs */

const en_action_edit = /** @type {(inputs: Action_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit`)
};

const es_action_edit = /** @type {(inputs: Action_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar`)
};

const fr_action_edit = /** @type {(inputs: Action_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifier`)
};

const de_action_edit = /** @type {(inputs: Action_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bearbeiten`)
};

const ja_action_edit = /** @type {(inputs: Action_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`編集`)
};

const zh_action_edit = /** @type {(inputs: Action_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`编辑`)
};

const ar_action_edit = /** @type {(inputs: Action_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تعديل`)
};

const id_action_edit = /** @type {(inputs: Action_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit`)
};

const it_action_edit = /** @type {(inputs: Action_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifica`)
};

const ru_action_edit = /** @type {(inputs: Action_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Редактировать`)
};

const pt_action_edit = /** @type {(inputs: Action_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar`)
};

const ko_action_edit = /** @type {(inputs: Action_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`수정`)
};

/**
* | output |
* | --- |
* | "Edit" |
*
* @param {Action_EditInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const action_edit = /** @type {((inputs?: Action_EditInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_EditInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_action_edit(inputs)
	if (locale === "es") return es_action_edit(inputs)
	if (locale === "fr") return fr_action_edit(inputs)
	if (locale === "de") return de_action_edit(inputs)
	if (locale === "ja") return ja_action_edit(inputs)
	if (locale === "zh") return zh_action_edit(inputs)
	if (locale === "ar") return ar_action_edit(inputs)
	if (locale === "id") return id_action_edit(inputs)
	if (locale === "it") return it_action_edit(inputs)
	if (locale === "ru") return ru_action_edit(inputs)
	if (locale === "pt") return pt_action_edit(inputs)
	return ko_action_edit(inputs)
});